defineCustomVueElement('csb-product-compatibility-badge', {
  name: 'Per Product Compatibility Checker',
  template: `<span class="csb-product-compatibility-badge" v-if="csbStore.currentModel != null && groupCompatibilityDecoded.length > 0">
    <span v-if="isCompatible && isStandard" class="compatible-compatible" :title="'This product IS compatible with your ' + csbStore.currentModel.brand + ' ' + csbStore.currentModel.name">
    </span>
    <span v-else-if="isCompatible" class="compatible-non-standard"  :title="'This product IS compatible with your ' + csbStore.currentModel.brand + ' ' + csbStore.currentModel.name + ', but may require a sprocket change'">
    </span>
    <span v-else class="compatible-not-compatible" :title="'This product IS NOT compatible with your ' + csbStore.currentModel.brand + ' ' + csbStore.currentModel.name">
    </span>
  </span>`,
  props: {
    groupCompatibility: { default: [] },
    chainSpec: { default: [] }
  },
  data() {
    return {
      chainSpecDecoded: [],
      groupCompatibilityDecoded: [],
      csbStore: useCsbStore()
    }
  },
  methods: {
    reset() {
      localStorage.setItem("model-picker-chosen", null)
    }
  },
  computed: {
    isStandard() {
      if (this.csbStore.currentModel.chain_spec == null || this.chainSpecDecoded.length == 0) {
        return true
      }
      return this.csbStore.currentModel == null ? false : this.chainSpecDecoded.includes(this.csbStore.currentModel.chain_spec)
    },
    isCompatible() {
      return this.csbStore.currentModel == null ? false : this.groupCompatibilityDecoded.includes(this.csbStore.currentModel.sub_group)
    }
  },
  async mounted() {
    this.chainSpecDecoded = JSON.parse(this.chainSpec)
    this.groupCompatibilityDecoded = JSON.parse(this.groupCompatibility)
    await this.csbStore.init()
  }
}, { plugins: [ piniaStore ] })